import cn from "classnames";
import BookShow from "components/shared/book/show";
import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import { parcelProviderTypes, parcelProviderTypesEnum } from "helpers/enums";
import { getInitialStateFromConfig, serializeReq } from "helpers/form";
import { viewContainer } from "helpers/redux";
import { requiredField } from "helpers/validators";
import React from "react";
import { applyCdekStatus, applyRussianPostStatus, getCdekStatus, getRussianPostStatus } from "sources/parcel";

const config = {
    name: {
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    isFinal: {
        label: "Конечный статус",
        inputProps: { name: "isFinal" },
        checkbox: true,
    },
    isSuccess: {
        label: "Успешный статус",
        inputProps: { name: "isSuccess" },
        checkbox: true,
    },
    provider: {
        label: "Система отслеживания",
        inputProps: { name: "provider" },
        options: parcelProviderTypes,
        required: true,
        validators: [requiredField],
    },
    operationCode: {
        label: "Код операции",
        inputProps: { name: "operationCode", type: "number", step: 1 },
        validators: [
            (value, data) => (data.provider === parcelProviderTypesEnum.RussianPost ? requiredField(value) : ""),
        ],
        required: true,
    },
    operationAttribute: {
        label: "Код атрибута",
        inputProps: { name: "operationAttribute", type: "number", step: 1 },
        validators: [
            (value, data) => (data.provider === parcelProviderTypesEnum.RussianPost ? requiredField(value) : ""),
        ],
        required: true,
    },
    code: {
        label: "Код",
        inputProps: { name: "code" },
        validators: [(value, data) => (data.provider === parcelProviderTypesEnum.Cdek ? requiredField(value) : "")],
        required: true,
    },
    id: {},
};

const initialState = getInitialStateFromConfig(config);

class AdminParcelStatusesShow extends BookShow {
    getItem = ({ match, provider }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            const getItem = provider === parcelProviderTypesEnum.RussianPost ? getRussianPostStatus : getCdekStatus;
            getItem(match.params).then((data) => {
                data.provider = provider;
                this.setState({ data, initial: data, ...defParams });
            });
        } else {
            this.setState(defParams);
        }
    };

    get dropdActions() {
        if (this.props.match.params.id) {
            return [{ text: "Удалить", action: this.actionClose }];
        } else {
            return [];
        }
    }

    apply = () => {
        const { match, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                const { provider, ...reqData } = state.data;
                const apply =
                    provider === parcelProviderTypesEnum.RussianPost ? applyRussianPostStatus : applyCdekStatus;
                return apply(serializeReq({ ...match.params, ...reqData })).then((res) => {
                    if (res) {
                        match.params.id ? this.update() : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderButton = () => {
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row panel__row--button">
                <div className={cname} onClick={this.apply}>
                    {this.props.match.params.id ? "Обновить" : "Сохранить"}
                </div>
            </div>
        );
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        const { provider } = this.state.data;
        const { config } = this.props;
        return (
            <>
                {this.renderField(config.name)}
                {this.renderCheckbox(config.isFinal)}
                {this.renderCheckbox(config.isSuccess)}
                {this.renderSelect(config.provider)}
                {provider === parcelProviderTypesEnum.RussianPost && (
                    <>
                        {this.renderField({ ...config.operationCode, validators: [requiredField] })}
                        {this.renderField({ ...config.operationAttribute, validators: [requiredField] })}
                    </>
                )}
                {provider === parcelProviderTypesEnum.Cdek &&
                    this.renderField({ ...config.code, validators: [requiredField] })}
                {this.renderButton()}
            </>
        );
    };

    render() {
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <Transition dir="full">
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </Transition>
        );
    }
}

const ConfiguredShow = (props) => <AdminParcelStatusesShow {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "admin-parcel-statuses");
